import { ROUTES } from '@/constants/constants';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LangSelector } from './LangSelector';
import {
  BottomRow,
  BrandBox,
  BrandRow,
  BrandTitle,
  ColumnHeading,
  Copyright,
  Description,
  FooterDivider,
  FooterLinkText,
  FooterRoot,
  FooterTopRow,
  LinksColumn,
} from './styles';

function Footer() {
  const { t, i18n } = useTranslation('web', { keyPrefix: 'components.layout.footer' });

  return (
    <FooterRoot>
      <FooterTopRow>
        <BrandBox>
          <BrandRow>
            <img src="/assets/images/logo.svg" alt={t('brand')} width="32" height="32" />
            <BrandTitle>Tailored-PDF</BrandTitle>
          </BrandRow>
          <Description>{t('description')}</Description>
        </BrandBox>

        <LinksColumn>
          <ColumnHeading>{t('product')}</ColumnHeading>
          <Link to={ROUTES.pricing(i18n.language)}>
            <FooterLinkText>{t('pricing')}</FooterLinkText>
          </Link>
        </LinksColumn>

        <LinksColumn>
          <ColumnHeading>{t('legal')}</ColumnHeading>
          <Link to={ROUTES.terms(i18n.language)}>
            <FooterLinkText>{t('terms')}</FooterLinkText>
          </Link>
          <Link to={ROUTES.policy(i18n.language)}>
            <FooterLinkText>{t('privacyPolicy')}</FooterLinkText>
          </Link>
          <Link to={ROUTES.refund(i18n.language)}>
            <FooterLinkText>{t('refundPolicy')}</FooterLinkText>
          </Link>
          <Link to={ROUTES.gdpr(i18n.language)}>
            <FooterLinkText>{t('gdpr')}</FooterLinkText>
          </Link>
        </LinksColumn>
      </FooterTopRow>

      <FooterDivider />

      <BottomRow>
        <Copyright>{`© ${new Date().getFullYear()} Tailored-PDF. ${t('rights')}`}</Copyright>
        <LangSelector />
      </BottomRow>
    </FooterRoot>
  );
}

export default Footer;
